import React, { useEffect, useState } from "react";
import { ActivityIndicator, Dimensions, Image, Linking, ScrollView, Text, TouchableOpacity, View } from "react-native";
import { MaterialIcons } from "@expo/vector-icons";
import { useNavigation } from "@react-navigation/core";
import * as Clipboard from 'expo-clipboard';

import HeaderDefault from "../../components/HeaderDefault";

import { styles } from "./styles";

import GradientButton from "../../components/GradientButton";
import AsyncStorage from "@react-native-async-storage/async-storage";
import { formatCoin } from "../../utils/formatNumber";
import toast from "../../utils/toast";
import paymentService from "../../services/paymentService";
import formatDate from "../../utils/formatDate";

const DepositBoleto = () => {
  const navigation = useNavigation();

  const [value, setValue] = useState(0);
  const [boletoCode, setBoletoCode] = useState('');
  const [docUrl, setDocUrl] = useState('');
  const [expirationDate, setExpirationDate] = useState();

  useEffect(() => {
    async function createBoletoPayment() {
      const value = parseFloat(await AsyncStorage.getItem('depositAmount'));
      setValue(value);
      const token = await AsyncStorage.getItem('JWT_TOKEN');
      try {
        const response = await paymentService.createBoleto(token, value);
        const { boleto_code, boleto_document_url, expiration_date } = response.data;
        console.log(response.data);
        setBoletoCode(boleto_code);
        setDocUrl(boleto_document_url);
        setExpirationDate(expiration_date);
      } catch (err) {
        console.log(err.response.data);
        toast('Algo deu errado. Por favor, tente novamente mais tarde.', "#DA1414");
        navigation.navigate('Home');
      }
    }
    createBoletoPayment();
  }, []);

  function openBoleto() {
    Linking.openURL(docUrl);
  }

  const [copied, setCopied] = useState(false);
  function copyToClipboard() {
    Clipboard.setString(boletoCode);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  }

  return (
    <View style={{ flex: 1 }}>
      <HeaderDefault title={"Depositar BRL"} />
      {
        !boletoCode ? (
          <View style={styles.activityIndicatorContainer}>
            <ActivityIndicator color="#1FBFB5" size="large" style={styles.activityIndicator} />
          </View>
        ) : (
          <View style={styles.container}>
            <View>
              <View style={styles.headerInfo}>
                <View>
                  <Text style={styles.title}>Boleto</Text>
                  <Text style={styles.value}>R$ {formatCoin(value)}</Text>
                </View>
                <View style={styles.dateContainer}>
                  <Text style={styles.bold}>Validade</Text>
                  <Text>{expirationDate && formatDate(expirationDate)}</Text>
                </View>
              </View>

              <Text style={styles.explanationText}>Copie o código do boleto ou efetue o download do documento.</Text>

              <TouchableOpacity onPress={openBoleto} style={styles.openButton}>
                <Text style={styles.copyText}>
                  Abrir boleto
                </Text>
              </TouchableOpacity>

              <View style={styles.codeContainer}>
                <View style={styles.codeHeader}>
                  <Text style={styles.bold}>Código</Text>
                  <TouchableOpacity onPress={copyToClipboard}>
                    <Text style={styles.copyText}>
                      {copied ? 'Copiado!' : 'Copiar'}
                    </Text>
                  </TouchableOpacity>
                </View>
                <Text>{boletoCode}</Text>
              </View>
            </View>
            <GradientButton onPress={() => navigation.navigate('Home')}>Finalizar</GradientButton>
          </View>
        )
      }
    </View>
  );
};

export default DepositBoleto;
